export default {
  methods: {
    beforePrintListener: () => {
      window.history.pushState('', '', '/')
    },
    afterPrintListener: () => window.history.back(),
    messageListener: (res) => {
      if (res.data.type === 'print') {
        window.print()
      }
    }
  },
  mounted() {
    // 打印相关准备工作
    window.onbeforeprint = this.beforePrintListener
    window.onafterprint = this.afterPrintListener
    window.addEventListener('message', this.messageListener)
    
    if (window.navigator.userAgent.indexOf('Firefox') > -1) {
      const pentagonTable = document.getElementsByClassName('pentagon-table')[0]
      if (pentagonTable) {
        pentagonTable.setAttribute(
          'style',
          'transform: scale(0.9);transform-origin: 0 0;width: 110%;margin-bottom: -25px;font-size:11px'
        )
      }
    }
  },
  beforeDestroy() {
    try {
      window.onbeforeprint = null
      window.onafterprint = null
      window.removeEventListener('message', this.messageListener)
    } catch (error) {
      console.error('[print mixin]被捕获:' + error)
    }
  }
}
